export enum OrderGeneralOption {
  Historic = 1,
  PrintTSO = 2,
  Recipes = 3,
  ManageTransport = 4,
  ListNFes = 5,
  OrderDetails = 6,
  OrderNotes = 7,
  NewOrderNote = 8,
  SetFulfilledItems = 9,
  ChangeCustomer = 10,
  RecipesV2 = 11,
  ReopenIncorrectlyDeliveredOrder = 12,
  PrintTSOV2A5 = 13,
  ProductGroups = 14,
  DigitalLensCertificates = 15,
  ManageLensCuttingMachineIntegration = 16,
  PrintTSOCssBarcode = 18,
  PrintTSOV2A5CssBarcode = 19,
}
